import type { FormattedFeedProductType } from '@/types'

type ComparableProductCardProps = {
  product: FormattedFeedProductType
  isChild?: boolean
}

export const areProductCardPropsEqual = (
  prevProps: ComparableProductCardProps,
  nextProps: ComparableProductCardProps
) =>
  prevProps.product.nomenclatureDto.code ===
    nextProps.product.nomenclatureDto.code &&
  prevProps.product.suppliersStock === nextProps.product.suppliersStock &&
  prevProps.isChild === nextProps.isChild
